import axios from "axios";

export const HOST = "https://www.wlglj.cn/abc";
// export const HOST = "https://www.wlglj.cn/test";

/**
 * 发送验证码
 * @param args 
 */
export const sendCodeMsg = (args: object) => {
  const url = `${HOST}/sys/api/exchange/user/ordersearch/sendordersearchcode`;
  axios.post(url, { ...args })
    .then(function (response) {
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
};

/**
 * 验证验证码
 * @param args 
 */
export const validateverificationcode = (args: object) => {
  const url = `${HOST}/sys/api/exchange/user/ordersearch/validateverificationcode`;
  return axios.post(url, { ...args })
    .then(function (response) {
      console.log(response);
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

